import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../apiConfig";

const initialState = {
  isLoading: false,
  variations: [],
  subvariation: [],

  error: null,
};

export const getVariation = createAsyncThunk(
  "variation/getVariation",
  async (id, thunkApi) => {
    try {
      const res = await api.get(`collections/variations/${id}`, {
        params: {
          populate: "product,product.gallery",
          pageSize: 10000,
        },
      });
      return { data: res.data.data }; // Adjust based on actual response structure
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const variationSlice = createSlice({
  name: "variations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVariation.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVariation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.variations = action.payload.data;

        state.error = null;
      })
      .addCase(getVariation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

// export const selectMenVariation = (state) => state.mainvariation.variations.filter(variation => variation?.name === 'Mens');
// export const selectWomenVariation = (state) => state.mainvariation.variations.filter(variation => variation.parent?.name === 'Womens');
// export const selectKidsVariation = (state) => state.mainvariation.variations.filter(variation => variation.parent?.name === 'Kids');
// export const selectHomeVariation = (state) => state.mainvariation.variations.filter(variation => variation?.name === 'Home');

export default variationSlice.reducer;
